<template>
    <div v-if="district">
        <section class="district-hero">
            <img class="district-hero-img" :src="district.image" :alt="district.imageAlt" loading="eager" decoding="async" @error="useFallbackImage" />
            <div class="district-hero-overlay"></div>
            <div class="district-hero-content">
                <h6 class="section-title text-white text-uppercase mb-3">{{ district.communityName }}</h6>
                <h1>{{ district.headline }}</h1>
                <p>{{ district.name }} kökenli hemşehrilerimizi Ankara'da ortak dayanışma çatısında buluşturuyoruz.</p>
                <a :href="whatsappUrl" target="_blank" rel="noopener" class="btn btn-primary py-3 px-5">
                    WhatsApp'tan Katıl
                </a>
            </div>
        </section>

        <section class="container-xxl py-5">
            <div class="container">
                <div class="row g-5 align-items-start">
                    <div class="col-lg-8">
                        <h6 class="section-title text-start text-primary text-uppercase">{{ district.name }}</h6>
                        <h2 class="mb-4">{{ district.name }}'in güzellikleri ve Ankara'daki hemşehri bağı</h2>
                        <p class="text-body district-lead mb-4">{{ district.intro }}</p>

                        <div class="row g-4">
                            <div v-for="highlight in district.highlights" :key="highlight" class="col-md-4">
                                <div class="district-highlight">
                                    <i class="fa fa-check text-primary mb-3"></i>
                                    <p class="mb-0">{{ highlight }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="district-search mt-5">
                            <h3 class="mb-3">Bu sayfa hangi aramalara cevap verir?</h3>
                            <p class="mb-0">
                                <span v-for="term in district.seoTerms" :key="term">{{ term }}</span>
                            </p>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="join-panel district-join-panel">
                            <h3 class="mb-3">{{ district.communityName }} grubuna katılın</h3>
                            <p class="mb-4">
                                İlçe derneklerimizin ve hemşehri gruplarımızın gücünü Ankara'da ortak iletişimle
                                büyütmek için hazır mesajla bize ulaşın.
                            </p>
                            <p class="join-message mb-4">"Derneğinize websitesinden katıldım, herkese merhabalar."</p>
                            <a :href="whatsappUrl" target="_blank" rel="noopener" class="btn btn-dark w-100 py-3">
                                Hazır Mesajla Katıl
                            </a>
                            <router-link to="/anasayfa" class="btn btn-outline-primary w-100 py-3 mt-3">
                                Ana Sayfaya Dön
                            </router-link>
                        </div>
                        <p class="district-credit mt-3 mb-0">{{ district.imageCredit }}</p>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div v-else class="container-xxl py-5">
        <div class="container text-center">
            <h1 class="mb-4">İlçe sayfası bulunamadı</h1>
            <router-link to="/anasayfa" class="btn btn-primary py-3 px-5">Ana Sayfaya Dön</router-link>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DISTRICTS, { districtWhatsappUrl } from '@/data/districts'

const route = useRoute()

const district = computed(() => DISTRICTS.find((item) => item.slug === route.params.slug))
const whatsappUrl = computed(() => district.value ? districtWhatsappUrl(district.value.name) : '#')

const useFallbackImage = (event) => {
    event.target.src = '/img/car2.png'
}

</script>
